import { useState, useEffect } from "react";
import { Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function ModalAspekUpdate(props) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState({ aspek: "" });

  useEffect(() => {
    if (props.show) {
      setForm({ aspek: props.dataUpdate?.aspek ?? "" });
    }
  }, [props.show, props.dataUpdate]);

  const handleChange = (event) => {
    setForm((old) => ({ ...old, [event.target.name]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.aspek.trim() || isSubmitting) return;

    setIsSubmitting(true);
    try {
      // Sementara mengubah dummy lewat Home; belum memanggil endpoint.
      const berhasil = props.onSave(form.aspek);
      if (berhasil) {
        ToastSuccess.fire({ icon: "success", title: "Aspek berhasil diperbarui (dummy)" });
        props.onHide();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-aspek"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-update-aspek" className="sims-modal-title">
            Update Aspek{props.kategoriNama ? ` - ${props.kategoriNama}` : ""}
          </h5>
        </div>
        <button type="button" className="sims-modal-close" onClick={props.onHide} aria-label="Tutup modal">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="sims-modal-body">
          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="aspek_update">
              Aspek <span>*</span>
            </label>
            <textarea
              id="aspek_update"
              className="sims-form-input pt-2"
              rows={4}
              style={{ minHeight: 110, resize: "vertical" }}
              name="aspek"
              value={form.aspek}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>
        </div>

        <div className="sims-modal-footer">
          <button type="button" className="sims-modal-cancel" onClick={props.onHide} disabled={isSubmitting}>
            Batal
          </button>
          <button type="submit" className="sims-modal-submit" disabled={isSubmitting || !form.aspek.trim()}>
            {isSubmitting ? (
              <><span className="sims-button-spinner" />Memperbarui...</>
            ) : (
              <><FontAwesomeIcon icon={faFloppyDisk} /> Perbarui</>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
